import axios from "@/plugins/axios";
import { getApiUrl } from "@/services/_apiUrl";

const apiUrl = getApiUrl();

export function fetchLicence() {
  return axios.get(apiUrl.licence.GET.DETAIL);
}

export function fetchSubmissionUsage() {
  return axios.get(apiUrl.submissionsUsage.GET.DETAIL);
}
